import React from 'react';
import { TrustedByContentfulModel } from 'src/api/models/TrustedBy';
import { TrustedByLogo, TrustedByLogoContainer } from './trustedBy.styles';

export interface TrustedByProps {
  logos: TrustedByContentfulModel['contentfulchildren'];
}

const TrustedByLogos = ({ logos }: TrustedByProps): JSX.Element => {
  return (
    <TrustedByLogoContainer>
      {
        logos.map((logo, index) => (
          <div  key={index}>
            <TrustedByLogo childImageSharp={logo.logo.gatsbyImageData} alt={logo.title} />
          </div>
        ))
      }
    </TrustedByLogoContainer>
  )
}

export default TrustedByLogos;
